import { useState } from 'react'
import { Checkbox } from '../Checkbox/Checkbox'
import { ButtonLogin } from '../SideBar/Menu.style'
import { Label, LinkStyled, Wrapper } from './BelowInput.style'

type MenuProps = {
  buttonText: string
  onclick: () => void
  isLembrarMe: boolean
  esqueciSenha?: () => void
}

export function BelowInput({
  buttonText,
  onclick,
  isLembrarMe,
  esqueciSenha,
}: MenuProps) {
  const [check, setCheck] = useState(false)

  return (
    <>
      {isLembrarMe ? (
        <Wrapper>
          <div>
            <Checkbox
              check="check"
              background
              top="6px"
              checked={check}
              onChange={() => setCheck(!check)}
            />
            <Label color="fonteColor" htmlFor="remember-me">
              Lembrar-me
            </Label>
          </div>
          <LinkStyled onClick={esqueciSenha}>Esqueci minha senha</LinkStyled>
        </Wrapper>
      ) : (
        ''
      )}
      <ButtonLogin onClick={onclick} buttonType="LARGE" type="button">
        {buttonText}
      </ButtonLogin>
    </>
  )
}
